import React from "react";
import MuiTableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";

/**
 * TableRow component wrapper for table rows.
 * Wraps Material-UI TableRow with theme integration.
 * 
 * @component
 * @example
 * <TableRow>
 *   <TableCell>Data 1</TableCell>
 *   <TableCell>Data 2</TableCell>
 * </TableRow>
 */
const TableRow = ({ children, ...props }) => {
  return <MuiTableRow {...props}>{children}</MuiTableRow>;
};

TableRow.propTypes = {
  /**
   * The content of the component, normally TableCell
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, the table row will shade on hover
   */
  hover: PropTypes.bool,
  /**
   * If true, the table row will have the selected shading
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI TableRow behavior

export default TableRow;

